import React from 'react';
import Dates from '@spa/shared/components/Filters/Groups/Dates';
import Places from '@spa/shared/components/Filters/Groups/Place';
import Tenants from '@spa/shared/components/Filters/Groups/Tenants';
import Landlord from '@spa/shared/components/Filters/Groups/Landlord';
import Typology from '@spa/shared/components/Filters/Groups/Typology';
import Registration from '@spa/shared/components/Filters/Groups/Registration';
import { getFieldsAreEqual } from './utils';

const memoizeComponent = component => fields => {
  const areEqual = getFieldsAreEqual(fields);

  return React.memo(component, areEqual);
};

const DatesGroup = memoizeComponent(Dates);
const PlacesGroup = memoizeComponent(Places);
const TenantsGroup = memoizeComponent(Tenants);
const LandlordGroup = memoizeComponent(Landlord);
const TypologyGroup = memoizeComponent(Typology);
const RegistrationGroup = memoizeComponent(Registration);

export { DatesGroup, PlacesGroup, TenantsGroup, LandlordGroup, TypologyGroup, RegistrationGroup };
